import React from 'react';
import type { BlockTrustBrand } from 'types/block-trust-brand';

import Image from 'next/image';
import { Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import Figure from './figure';

const TrustBrand: React.FC<BlockTrustBrand> = ({ sectionId, cards }) => {
  return (
    <Wrap id={sectionId} className="">
      {cards?.length > 0 ? (
        <ul className="grid md:grid-cols-2 gap-y-8 gap-x-16">
          {cards?.map(({ image, title, content, showTrustpilotStamp }, idx) => {
            return (
              <li
                key={`trust-brand-item-${idx}`}
                className="grid justify-items-center gap-y-8 md:gap-y-4 border border-gray-200 rounded-lg p-8"
              >
                {image && (
                  <Figure
                    className="inline-flex items-center md:h-60"
                    {...image}
                  />
                )}
                {title?.length > 0 && (
                  <HeadingBody
                    className="text-center"
                    level="2"
                    title={title}
                    tagName="h2"
                  />
                )}
                {content?.length > 0 && (
                  <WysiwygContent
                    content={content}
                    largerParagraph={true}
                    className="max-w-lg text-center"
                  />
                )}
                {showTrustpilotStamp && (
                  <Image
                    src="/trustpilot_mark.svg"
                    alt=""
                    className="mt-4"
                    loading="lazy"
                    width={157}
                    height={61}
                  />
                )}
              </li>
            );
          })}
        </ul>
      ) : null}
    </Wrap>
  );
};

export default TrustBrand;
